import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import CenteredCircularProgress from 'components/CenteredCircularProgress';
import { useStorageMetrics } from './api/getStorageMetrics';

const MetricTrackerTable = () => {
  const { data: metrics, isLoading } = useStorageMetrics({});

  if (isLoading) return <CenteredCircularProgress />;

  if (!metrics) return <></>;

  return (
    <TableContainer sx={{ maxHeight: '258px' }}>
      <Table size='small' stickyHeader>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant='body2'>Data Storage Rate</Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2'>{metrics.data_rate}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant='body2'>Database Size</Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2'>{metrics.database_size}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant='body2'>Disk Size</Typography>
            </TableCell>
            <TableCell>
              <Typography variant='body2'>{metrics.disk_size}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{ borderBottom: 'none' }}>
              <Typography variant='body2'>Disk Free Space</Typography>
            </TableCell>
            <TableCell sx={{ borderBottom: 'none' }}>
              <Typography variant='body2'>{metrics.disk_free_space}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MetricTrackerTable;
